import { render, staticRenderFns } from "./SmplEditStprChild.vue?vue&type=template&id=290e51c8&scoped=true&"
import script from "./SmplEditStprChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditStprChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditStprChild.vue?vue&type=style&index=0&id=290e51c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e51c8",
  null
  
)

export default component.exports